module.exports = __webpack_public_path__ + "img/integral-bg.72e1cb07.png";